import React from "react";
import {getPrivacyOffers, getRegistrationFields } from "../../../utils";
import {services} from "@offline/components/SignIn/SocialLogin";
import AuthenticationBlock from "../../../blocks/AuthenticationBlock";

import "./style.scss";

const UserAuthenticationModal = ({event, $locale, description = '', onClose}) => {
    const {moduleAuth, moduleSettings} = event;

    const onLoginSuccess = () => {
        onClose({isAuth: true});
    }

    const customDescription = $locale.getProperty(moduleAuth, 'customDescription')
        || $locale.getProperty(moduleSettings, 'loginSubtitle')
    ;

    const eventHasAuth = !!(event?.moduleAuth && (['guest', 'email', 'phone', ...services].find((auth) => event.moduleAuth[auth])));

    if (!eventHasAuth) {
        return <p style={{maxWidth: '35rem', textAlign: 'center'}}>{$locale.get('auth.activity.needAuth')}</p>
    }

    return (
        <div className="user-auth-modal login-page">
            <AuthenticationBlock
                eventKey={event.eventKey}
                eventName={$locale.getProperty(event, 'name')}
                timeStart={event.timeStart}
                customDescription={description || customDescription}
                eventPremoderation={moduleAuth.accessPreModeration}
                participationType={event.participationType}
                $locale={$locale}
                loginWithEmailEnabled={moduleAuth.email}
                loginWithNameEnabled={moduleAuth.guest}
                loginWithPhoneEnabled={moduleAuth.phone}
                externalServices={services.filter((name) => moduleAuth[name])}
                ssoIconUrl={moduleAuth.ssoIconUrl}
                registrationFields={getRegistrationFields(event, $locale.getProperty)}
                privacyOffer={getPrivacyOffers(event, $locale)}
                moduleSettings={event.moduleSettings}
                moduleAuth={event.moduleAuth}
                eventAuthRequired={moduleAuth.require}
                hideInfoBlock={true}
                corporateMail={moduleAuth.corporateMail ?? false}
                participationFormatLabels={moduleAuth.participationFormatLabels ?? []}
                registrationType={moduleAuth.registrationType ?? 'hybrid'}
                onLoginSuccess={onLoginSuccess}
            />
        </div>
    );
};

export default UserAuthenticationModal;
